export const ReturnableTypeEnum = {
  GOODS_RECEIPT: "GOODS_RECEIPT",
  PURCHASE_INVOICE: "PURCHASE_INVOICE",
  NON_INVOICE: "NON_INVOICE", // Internal value for UI, sent as null to backend
};
